import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import style from './ChatBot.module.css';
import HeadSub from '../../../components/comm/HeadSub';
import imgAvata from '../../../images/common/img_chat_mascot.svg';
import iconAttach from '../../../images/common/i_chat_attach.svg';
import iconVoice from '../../../images/common/i_chat_voice.svg';


const QUICK_REPLIES = ['좋아요!', '다른운동', '장비없이', '실내로', '왜 이거야?', '더 쉬운걸로'];

const DietChatBot = () => {
    const { state } = useLocation();
    const mode = state?.mode === 'exercise' ? 'exercise' : 'diet';

    const [isInputFocused, setIsInputFocused] = useState(false);
    const isAndroid = /Android/i.test(navigator.userAgent);

    const inputRef = useRef(null);
    const chatEndRef = useRef(null);
    const [textQuestion, setTextQuestion] = useState('');
    const [chatList, setChatList] = useState([]);
    const isInit = useRef(false);

    const [isSending, setIsSending] = useState(false);   // 채팅 입력 보냄
    const [showQuick, setShowQuick] = useState(true);    // 추천 리스트

    const handleQuickReply = (text) => {
        if (isSending) return;

        setChatList(prev => [
            ...prev,
            { type: 'user', text, chatTime: getCurrentTime() },
        ]);
    };


    // 날짜 유틸
    const getCurrentDateStr = () => {
        const now = new Date();
        const y = now.getFullYear();
        const m = String(now.getMonth() + 1).padStart(2, '0');
        const d = String(now.getDate()).padStart(2, '0');
        const days = ['일', '월', '화', '수', '목', '금', '토'];
        return `${y}.${m}.${d}(${days[now.getDay()]})`;
    };
    const getCurrentTime = () => new Date().toLocaleTimeString('ko-KR', { hour: '2-digit', minute: '2-digit' });

    // 모드별 초기 메시지 하드코딩
    useEffect(() => {
        if (isInit.current) return;
        isInit.current = true;

        const time = getCurrentTime();
        const dateLine = { type: 'date', dateStr: getCurrentDateStr() };

        setChatList([
            dateLine,
            { type: 'bot', text: '👋 안녕하세요! 저는 건강 관리를 도와드리는 웰비이에요.\n디팜님, 오늘은 가볍게 드실 수 있는 식단을 추천드릴께요!', chatTime: time },
            { type: 'recommend', title: '🎯 OO님을 위한 식단 추천', name: '아보카도 새우 샐러드', desc: '아보카도와 새우는 칼로리와 나트륨이 낮은 건강식이에요.' },
            { type: 'action', label: '다른 식단 추천받기' },
            { type: 'feedback', question: '해당 메뉴 추천이 별로 셨을까요?', options: ['네', '아니오'] },
        ]);
        
    }, [mode]);

    useEffect(() => {
        chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [chatList]);


    const handleSend = () => {
        const message = textQuestion.trim();

        if (!message || isSending) return;

        // 애니메이션 시작
        setIsSending(true);

        // 실제 채팅 메시지 추가
        const time = getCurrentTime();

        setChatList(prev => [
            ...prev,
            {
                type: 'user',
                text: message,
                chatTime: time,
            }
        ]);

        // 입력창 초기화
        setTextQuestion('');

    };


    const renderItem = (chat, index) => {
        switch (chat.type) {
            case 'date':
                return (
                    <div key={index} className={style['hr-line']}>
                        <span>{chat.dateStr} 오늘</span>
                    </div>
                );
            case 'user':
                return (
                    <div key={index} className={style['user-talk-box']}>
                        <span className={style['date-txt']}>{chat.chatTime}</span>
                        <p>{chat.text}</p>
                    </div>
                );
            case 'bot':
                return (
                    <div key={index} className={style['ai-talk-box']}>
                        <strong className={style['ai-avatar']}>
                            <img src={imgAvata} alt="" />
                        </strong>
                        <div className={style['ai-box']}>
                            <div className={style['text-box']}>
                                <div className={style['p-group']}>
                                    <p style={{ whiteSpace: 'pre-line' }}>{chat.text}</p>
                                </div>
                                <span className={style['date-txt']}>{chat.chatTime}</span>
                            </div>
                        </div>
                    </div>
                );
            case 'recommend':
                return (
                    <div key={index} className={style['recommend-card']}>
                        <strong className={style['recommend-title']}>{chat.title}</strong>
                        {chat.name && <p className={style['recommend-name']}>{chat.name}</p>}
                        {chat.desc && <p className={style['recommend-desc']}>{chat.desc}</p>}
                    </div>
                );
            case 'action':
                return (
                    <div key={index} className={style['action-box']}>
                        <button className={style['action-btn']}>{chat.label}</button>
                    </div>
                );
            case 'feedback':
                return (
                    <div key={index} className={style['feedback-box']}>
                        <p className={style['feedback-q']}>{chat.question}</p>
                        <div className={style['feedback-opts']}>
                            {chat.options.map((opt, i) => (
                                <button key={i} className={style['feedback-btn']}>{opt}</button>
                            ))}
                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <>
            <HeadSub title="챗봇" />
            <div id="sub-content" data-layout="blue">
                <div className="inner-wrap" data-pad-type="b">
                    {chatList.map(renderItem)}
                    <div ref={chatEndRef} />
                </div>

                {/* 추천 답변 칩 */}
                {showQuick && QUICK_REPLIES.length > 0 && (
                    <div
                        className={style['quick-reply-box']}
                        style={{
                            bottom: (isInputFocused && isAndroid)
                                ? 'calc(var(--sp-76) + env(keyboard-inset-height, 0px))'
                                : 'var(--sp-76)',
                        }}
                    >
                        <ul className={style['quick-reply-list']}>
                            {QUICK_REPLIES.map((text) => (
                                <li key={text}>
                                    <button
                                        type="button"
                                        className={style['quick-reply-chip']}
                                        onClick={() => handleQuickReply(text)}
                                    >
                                        {text}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                <div className={style['bottom-fixed-box']}
                    style={{
                        bottom: (isInputFocused && isAndroid) ? 'env(keyboard-inset-height, 0px)' : '0px',
                    }}>
                        
                    <button className={style['attach-btn']}>
                        <img src={iconAttach} alt="첨부파일 추가버튼" />
                        <span className='blind'>첨부파일</span>
                    </button>    
                    
                    <div className={style['in-box']}>
                        <div className={style['input-box']}>
                            <input
                                ref={inputRef}
                                type="text"
                                placeholder="내용을 입력하세요"
                                value={textQuestion}
                                onChange={(e) => setTextQuestion(e.target.value)}
                                onFocus={() => setIsInputFocused(true)}
                                onBlur={() => setIsInputFocused(false)}
                            />
                        </div>
                    </div>
                    <button className={style['voice-btn']}>
                        <img src={iconVoice} alt="음성버튼" />
                        <span className='blind'>음성입력</span>
                    </button>    
                    <button 
                        className={`${style['push-btn']} ${isSending ? style['sending'] : ''}`}
                        disabled={!textQuestion.trim() || isSending}
                        onClick={handleSend}
                        onAnimationEnd={() => setIsSending(false)}
                        aria-label="보내기"
                    />
                </div>
            </div>
        </>
    );
};

export default DietChatBot;